import React from 'react'
import FlowView from 'components/core/FlowView'
import { connect } from 'react-redux'
import { LinkedInput } from 'components/basic'
import { Installation } from 'config'
import http from 'API/http'

class LoginPage extends FlowView {
  constructor (props) {
    super(props, 'Login')
    this.state = {
      username: '',
      password: ''
    }
    window.addEventListener('keydown', e => e.keyCode === 13 && this.state.subpage === 'LOGIN' && !window.localStorage.getItem('flow_basic_auth') && this.handleSubmit())
  }
  componentDidMount () {
    var user = window.localStorage.getItem('flow_basic_auth')
    if (!user) return
    user = JSON.parse(user)
    this.setState({
      username: user.username,
      password: user.password
    }, () => {
      setTimeout(() => {
        this.handleSubmit()
      }, 0)
    })
  }
  async handleSubmit () {
    // eslint-disable-next-line
    var err, res
    [err, res] = await http.get('credentials/login', {}, {
      username: this.state.username,
      password: this.state.password
    })
    if (err) return this.setState({error: res.cause || true})
    this.props.dispatch({
      type: 'SET_BASIC_AUTH',
      payload: {
        username: this.state.username,
        password: this.state.password
      }
    })
    this.props.dispatch({
      type: 'SET_LOGIN',
      payload: {
        token: '',
        user: res.data
      }
    })
    window.localStorage.setItem('flow_basic_auth', JSON.stringify({
      username: this.state.username,
      password: this.state.password
    }))
    if (window.location.hash.indexOf('login') !== -1) {
      window.location.hash = '/installation'
    }
  }
  render () {
    return (
      <div className='site-wrapper sidebar-active'>
        <nav className='navbar navbar-fixed-top navbar-default'>
          <div className='container-fluid'>
            <div className='navbar-header'>
              <a className='navbar-brand' href='/#/'><img src='/static/flowlogo.svg' width='40' height='40' /> <span>Flow</span></a>
            </div>
            <ul className='nav navbar-nav navbar-right'>
              <li>
                <a className='header-button'>{Installation.ISP}</a>
              </li>
            </ul>
          </div>
        </nav>
        <div className='login-page'>
          <div className='login-box'>
            <img src='/static/flowlogo.svg' className='flow-login-logo' width='120' />
            <div className={'alert alert-danger ' + (!this.state.error ? 'hidden' : '')}>
              {(typeof this.state.error !== typeof true) ? this.state.error : 'Wrong username or password, please try again'}
            </div>
            <div className='form-group'>
              <label>Username</label>
              <LinkedInput context={this} path='username' />
            </div>
            <div className='form-group'>
              <label>Password</label>
              <LinkedInput type='password' context={this} path='password' />
            </div>
            <div className='row'>
              <div className='col-xs-12'>
                <a className='btn btn-primary pull-right' onClick={e => this.handleSubmit()}>ENTER</a>
              </div>
            </div>
            <span className='maintrac-login-logo'>{Installation.ISP}</span>
          </div>
        </div>
      </div>
    )
  }
}
// eslint-disable-next-line
LoginPage = connect(state => state)(LoginPage)
export default LoginPage



// WEBPACK FOOTER //
// ./src/projects/flow-gui-installation/login.js